import { render, staticRenderFns } from "./ClassificationDegreeDelete.vue?vue&type=template&id=090e2376&"
import script from "./ClassificationDegreeDelete.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports